import { render, staticRenderFns } from "./DropboxEmbed.vue?vue&type=template&id=ae850b24"
import script from "./DropboxEmbed.vue?vue&type=script&lang=js"
export * from "./DropboxEmbed.vue?vue&type=script&lang=js"
import style0 from "./DropboxEmbed.vue?vue&type=style&index=0&id=ae850b24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QInnerLoading,QSpinner,QCardSection,QBtn});
